<div class="login-body">
    <img class="login-image animated fadeIn" src="images/logoBlanco_432x75.png" alt="Logo">
    @if (ready()) {
        @if (loading()) {
            <div class="login-loading">
                <p-progressSpinner strokeWidth="4" aria-label="Validando sesión" />
                <span>Validando sesión...</span>
            </div>
        } @else {
            <div class="login-form animated fadeIn">
                @if (showCredentialsLogin()) {
                    <div class="form-group">
                        <label for="email">Correo electrónico</label>
                        <input
                            id="email"
                            type="email"
                            class="form-input"
                            placeholder="correo@ejemplo.com"
                            [(ngModel)]="email"
                            (keydown.enter)="loginWithCredentials()"
                            autocomplete="username"
                        />
                    </div>
                    <div class="form-group">
                        <label for="password">Contraseña</label>
                        <div class="password-wrapper">
                            <input
                                id="password"
                                [type]="showPassword ? 'text' : 'password'"
                                class="form-input"
                                placeholder="••••••••"
                                [(ngModel)]="password"
                                (keydown.enter)="loginWithCredentials()"
                                autocomplete="current-password"
                            />
                            <button
                                type="button"
                                class="toggle-password"
                                (click)="showPassword = !showPassword"
                                [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                            >
                                <i [class]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                            </button>
                        </div>
                    </div>
                    <button class="login-button credentials-button" (click)="loginWithCredentials()">
                        Iniciar sesión <i class="fas fa-sign-in-alt"></i>
                    </button>

                    <div class="login-divider">
                        <span>o</span>
                    </div>
                }

                <button class="login-button okta-button" (click)="loginWithOkta()">
                    Iniciar sesión con GateOne <i class="fas fa-sign-in-alt"></i>
                </button>
            </div>
        }
    }
</div>
